import { paginatedIndexRouteOptions } from './paginatedIndexQuery';

/**
 * Route helper utilities for Specialisations.
 *
 * Specialisations are a single global resource. Each record has a site_context,
 * but CRUD lives exclusively under /admin/specjalizacje. The siteContext
 * argument is kept for call-site compatibility but ignored.
 */
export function createSpecialisationRouteHelper(_siteContext, routes) {
  return {
    index: (extra) => routes.admin_specialisations(paginatedIndexRouteOptions(extra)),
    edit: (id) => routes.edit_admin_specialisation(id, paginatedIndexRouteOptions()),
    update: (id) => routes.admin_specialisation(id, paginatedIndexRouteOptions()),
    destroy: (id) => routes.admin_specialisation(id, paginatedIndexRouteOptions()),
    reorder: () => routes.reorder_admin_specialisations(),
  };
}
